<template>
   <div class="limit-page">
      <div class="pg-breadcrumb">
         <div class="breadcrumb-item em">派送專線</div>
         <div class="breadcrumb-item">待派送訂單</div>
      </div>
      <div class="content">
         <div>
            <span style="margin-right: 20px;">包裹設定</span>
            <span class="pg-btn style1" @click="handleAdd">新增</span>
         </div>

         <div class="content-info">
            <Table :columns="table.columns" :data="table.data" border>
               <template slot-scope="{ row, index }" slot="action">
                  <span class="pg-btn style2" @click="handleEdit(index,row)">修改</span>
                  <span class="pg-btn style3" @click="handleDel(index,row)">删除</span>
               </template>
               <template slot-scope="{ row, index }" slot="status">
                  <Switchs true-color="#51f4a9" v-model="row.status" @on-change="changeStatus(index,row)"/>
               </template>
            </Table>
         </div>
      </div>

      <div class="pop-box">
         <Modal
            v-model="showModal"
            width="360"
            title="新增"
            @on-ok="ok"
            @on-cancel="cancel">
            <Form>
               <FormItem>
                  <label>名称</label>
                  <Input v-model="form.name" clearable type="text"></Input>
               </FormItem>
               <FormItem>
                  <label>最小</label>
                  <Input v-model="form.interval_start" clearable type="number"></Input>
               </FormItem>
               <FormItem>
                  <label>最大</label>
                  <Input v-model="form.interval_end" clearable type="number"></Input>
               </FormItem>
               <FormItem>
                  <label style="margin-right: 12px;">是否开启</label>
                  <Switchs true-color="#51f4a9" v-model="form.status"/>
               </FormItem>
            </Form>
         </Modal>
      </div>
   </div>
</template>

<script>
export default {
   name: "deliveryareaLimit",
   data() {
      return {
         showModal: false,
         form: {
            id: '',
            name: '',
            interval_start: '',
            interval_end: '',
            status: false
         },
         table: {
            columns: [
               {
                  title: '操作',
                  slot: 'action'
               },
               {
                  title: '包裹',
                  key: 'name'
               },
               {
                  title: '最小值',
                  key: 'interval_start'
               },
               {
                  title: '最大值',
                  key: 'interval_end'
               },
               {
                  title: '是否开启',
                  key: 'status',
                  slot: 'status'
               }
            ],
            data: []
         }
      }
   },
   created() {
      this.getLimitList()
   },
   methods: {
      async ok() {
         let data = {
            id: this.form.id,
            name: this.form.name,
            interval_start: this.form.interval_start,
            interval_end: this.form.interval_end,
            status: this.form.status ? 1 : 0
         },url = this.$Api.deliveryLimitUpdate;

         if (!data.id) {
            url = this.$Api.deliveryLimitAdd
            delete data.id
         }

         const {code, msg} = await this.$Rq.requestAuth({url, method: 'post', data})
         this.$message.success(msg)
         this.getLimitList();
      },
      cancel() {
         this.form = {
            id: '',
            name: '',
            interval_start: '',
            interval_end: '',
            status: false
         }
      },
      handleAdd() {
         this.cancel();
         this.showModal = true
      },
      async handleDel(index,row) {
         const {code, msg} = await this.$Rq.requestAuth({url: this.$Api.deliveryLimitDel, method: 'post', data: {id: row.id}})
         this.$message.success(msg)
         this.getLimitList();
      },
      handleEdit(index,row) {
         this.form = {
            id: row.id,
            name: row.name,
            interval_start: row.interval_start,
            interval_end: row.interval_end,
            status: row.status
         }
         this.showModal = true
      },
      changeStatus(index, row) {
         this.form = {
            id: row.id,
            name: row.name,
            interval_start: row.interval_start,
            interval_end: row.interval_end,
            status: row.status
         }
         this.ok();
      },
      async getLimitList() {
         const {code, data: { data }} = await this.$Rq.requestAuth({url: this.$Api.deliveryLimitGet, method: 'get'})
         if (code === 0) {
            this.table.data = data.map(item => {
               item.status = item.status == 1 ? true : false
               return item;
            })
         }
      },
   }
}
</script>

<style scoped lang="scss">
.limit-page {
   .content {
      background-color: #FFFFFF;
      padding: 25px 48px;

      .content-info {
         margin-top: 30px;
      }

      .pg-btn {
         display: inline-block;
         vertical-align: middle;
         width: 60px;
         height: 35px;
         line-height: 35px;
         background: #fff;
         text-align: center;
         font-size: 14px;
         color: #999999;
         cursor: pointer;
         margin-right: 20px;
         text-decoration: none;
         border-radius: 3px;
         box-shadow: 0 2px 4px rgba(153, 153, 153, 0.5);
         -webkit-user-select: none;
         -moz-user-select: none;
         -ms-user-select: none;
         user-select: none;

         &:last-of-type {
            margin-right: 0;
         }

         &.style1 {
            color: #fff;
            background: rgba(255, 101, 101, 1);
            box-shadow: 0 2px 4px rgba(255, 101, 101, 0.5);
         }

         &.style2 {
            color: #fff;
            background: rgba(101, 132, 255, 1);
            box-shadow: 0 2px 4px rgba(101, 132, 255, 0.5);
         }

         &.style3 {
            color: #fff;
            background: #FF9A65;
            box-shadow: 0 2px 4px rgba(255, 154, 101, 0.5);
         }
      }
   }

   .pop-box {

      .pg-form-inline {

      }
   }

}

</style>
